import { render, staticRenderFns } from "./_news.vue?vue&type=template&id=0565a0b2&lang=pug&"
import script from "./_news.vue?vue&type=script&lang=js&"
export * from "./_news.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports